import { ValidatorFn } from '@angular/forms';
import { IsElectricMeterValidator } from '@shared/validators/electric-meter/is-electric-meter';
import { IsElectricMeterCabinetValidator } from '@shared/validators/electric-meter/is-electric-meter-cabinet';
import { IsElectricMeterProviderValidator } from '@shared/validators/electric-meter/is-electric-meter-provider';

export class U2bElectricMeterValidators {
    private static _isElectricMeterProviderValidator = new IsElectricMeterProviderValidator();

    public static isElectricMeter(message?: string): ValidatorFn {
        return new IsElectricMeterValidator(message).asValidatorFn();
    }

    public static isElectricMeterCabinet(message?: string): ValidatorFn {
        return new IsElectricMeterCabinetValidator(message).asValidatorFn();
    }

    public static isElectricMeterProvider(): ValidatorFn {
        return this._isElectricMeterProviderValidator.asValidatorFn();
    }
}
